import ApiService from '../../../../../services/ApiService'
import GeneralService from '../../../../../services/GeneralService'
import InstitutionInactive from '../../../Institutions/components/institutionInactive/institutionInactive.vue'

export default {
  components: {
    InstitutionInactive,
  },

  created() {
    this.userType = JSON.parse(localStorage.getItem('institution')).userType
    const institution = JSON.parse(localStorage.getItem('institution'))
    this.institutionId = institution.id
    this.institutionInactive = institution.status == 1
    this.workshopType = institution.workshopType
    window.scrollTo(0, 0)
    this.getManufacturers()
    this.getUndiades()
    this.getStandardEquipment()
    this.getDepartments()
    this.getCostCenters()
    this.getSuppliers()
  },

  data: () => ({
    subDepartmentId: '',
    errorMessage: '',
    loading: false,
    unidadeLoading: false,
    standardEquipmentLoading: false,
    departmentLoading: false,
    firstValid: true,
    secondValid: true,
    thirdValid: true,
    error: false,
    confirmDialog: false,
    fieldUnidade: true,
    fieldSubDepartment: false,
    fieldDepartment: false,
    fieldStandardEquipment: true,
    fieldEquipment: true,
    fieldManufacturer: false,
    fieldModel: false,
    fieldSituation: false,
    fieldSupplier: false,
    fieldAnvisa: false,
    institutionInactive: false,
    quantity: '',
    step: 1,
    workshopType: null,
    institutionId: null,
    unidadeId: 0,
    unidades: [],
    standardEquipmentId: 0,
    standardEquipments: [],
    departmentId: 0,
    departments: [],
    costCenterId: null,
    costCenters: [],
    supplierId: 0,
    suppliers: [],
    equipment: [],
    userType: null,
    equipmentName: '',
    manufacturer: '',
    model: '',
    anvisa: '',
    situation: null,
    indexAbc: null,
    lifeExpectancy: null,
    criticality: null,
    situations: [
      'Aluguel',
      'Comodato',
      'De médico/Equipe',
      'Empréstimo',
      'Próprio',
      'Terceiros',
      'Convênio',
    ],
    unidadeRules: [(v) => !!v || 'Unidade requerida'],
    quantityRules: [
      (v) => !!v || 'Quantidade requerida',
      (v) => (v && v != 0) || 'Quantidade tem que ser maior que zero',
    ],
    standardEquipmentRules: [(v) => !!v || 'Equipamento padrão requerido'],
    departmentRules: [(v) => !!v || 'Setor requerido'],
    nameRules: [
      (v) => !!v || 'Equipamento requerido',
      (v) =>
        (v && v.length <= 128) ||
        'Equipamento deve ter no máximo 128 caracteres',
    ],
    manufacturerRules: [
      (v) =>
        !v || v.length <= 128 || 'Fabricante deve ter no máximo 128 caracteres',
    ],
    modelRules: [
      (v) => !v || v.length <= 64 || 'Modelo deve ter no máximo 64 caracteres',
    ],
    serialNumberRules: [
      (v) =>
        !v || v.length <= 25 || 'Nº de série deve ter no máximo 25 caracteres',
    ],
    propertyCodeRules: [
      (v) =>
        !v ||
        v.length <= 20 ||
        'Cód. patrimônio deve ter no máximo 20 caracteres',
    ],
    numberAnvisaRules: [
      (v) =>
        !v ||
        v.length <= 20 ||
        'Número Anvisa deve ter no máximo 20 caracteres',
    ],
    apiService: new ApiService(),
    generalService: new GeneralService(),
    manufacturers: [],
    manufLoading: false,
  }),

  computed: {
    subDepartments() {
      const department = this.departments.find((x) => x.id == this.departmentId)
      return department ? department.subDepartments : []
    },

    buttonText() {
      switch (this.step) {
        case 3:
          return 'Adicionar'
        default:
          return 'Próximo'
      }
    },
  },

  methods: {
    getManufacturers() {
      this.manufLoading = true
      this.apiService
        .get(`manufacturer/list/${this.institutionId}`)
        .then((response) => {
          this.manufacturers = response.content
          this.manufLoading = false
        })
        .catch(() => {
          this.manufLoading = false
        })
    },

    close() {
      this.$router.push('/equipment')
    },

    next() {
      switch (this.step) {
        case 1:
          if (this.$refs.firstForm.validate()) {
            this.step++
          }
          break
        case 2:
          if (this.$refs.secondForm.validate()) {
            this.equipment = []

            for (let i = 0; i < this.quantity; i++) {
              const manuf = this.manufacturers.find(
                (x) => x.name == this.manufacturer
              )

              const equipment = {
                InstitutionId: this.institutionId,
                UnidadeId: this.unidadeId,
                DepartmentId: this.departmentId,
                SubDepartmentId: this.subDepartmentId,
                CostCenterId: this.costCenterId,
                InstitutionStandardEquipmentId: this.standardEquipmentId,
                DegreeImportance: this.indexAbc,
                LifeExpectancy: this.lifeExpectancy,
                Criticality: this.criticality,
                Name: this.equipmentName,
                manufacturer: manuf ? manuf.name : null,
                manufacturerId: manuf ? manuf.id : null,
                Model: this.model != '' ? this.model : null,
                NumberAnvisa: this.anvisa != '' ? this.anvisa : '',
                EquipmentAcquisitionSituation:
                  this.situation != null
                    ? this.situations.indexOf(this.situation)
                    : null,
                SupplierId: this.supplierId < 1 ? null : this.supplierId,
                SerialNumber: null,
                PropertyCode: null,
              }
              this.equipment.push(equipment)
            }
            this.step++
          }
          break
        case 3:
          console.log(this.$refs.thirdForm)
          if (this.$refs.thirdForm.validate()) {
            this.confirmDialog = true
          }
          break
      }
    },

    showSuccess(message) {
      this.$emit('show', message)
    },

    selectedStandardEquipment() {
      const standardEquipmentInstitution = this.standardEquipments.find(
        (x) => x.id === this.standardEquipmentId
      )
      this.equipmentName = standardEquipmentInstitution.standardEquipment.name
      this.lifeExpectancy =
        standardEquipmentInstitution.standardEquipment.lifeExpectancy
      this.indexAbc = standardEquipmentInstitution.standardEquipment.indexAbc
      this.criticality = this.calculateCriticality(
        standardEquipmentInstitution.standardEquipment
      )
    },

    selectedStandardEquipmentByDistinct(item) {
      const standardEquipmentInstitution = this.standardEquipments.find(
        (x) => x.id === item.institutionStandardEquipmentId
      )
      item.EquipmentName = standardEquipmentInstitution.standardEquipment.name
      item.LifeExpectancy =
        standardEquipmentInstitution.standardEquipment.lifeExpectancy
      item.IndexAbc = standardEquipmentInstitution.standardEquipment.indexAbc
      item.DegreeImportance = item.IndexAbc
      item.Criticality = this.calculateCriticality(
        standardEquipmentInstitution.standardEquipment
      )
    },

    calculateCriticality(standardEquipment) {
      let functionScore = 0
      let riskScore = 0
      let indexAbcScore = 0

      switch (standardEquipment.functionEquipment) {
        case 1:
          functionScore = 4
          break
        case 2:
          functionScore = 6
          break
        case 3:
          functionScore = 2
          break
        case 4:
          functionScore = 10
          break
        case 5:
          functionScore = 8
          break
        default:
          functionScore = 0
          break
      }

      switch (standardEquipment.equipmentRisk) {
        case 1:
          riskScore = 5
          break
        case 2:
          riskScore = 7
          break
        case 3:
          riskScore = 1
          break
        case 4:
          riskScore = 3
          break
        default:
          riskScore = 0
          break
      }

      switch (standardEquipment.indexAbc) {
        case 'A':
          indexAbcScore = 10
          break
        case 'B':
          indexAbcScore = 5
          break
        default:
          indexAbcScore = 0
          break
      }

      return functionScore + riskScore + indexAbcScore
    },

    async getUndiades() {
      this.unidadeLoading = true

      await this.apiService
        .get(`unidade/list/${this.institutionId}`)
        .then((response) => {
          this.unidades = response.content
        })
        .catch((err) => {
          this.errorMessage = err.body.message
          this.error = true

          setTimeout(() => {
            this.error = false
          }, 4000)
        })

      this.unidadeLoading = false
    },

    async getStandardEquipment() {
      this.standardEquipmentLoading = true

      this.standardEquipments =
        await this.generalService.getStandardEquipmentsByInstitution(
          this.institutionId
        )

      this.standardEquipmentLoading = false
    },

    async getDepartments() {
      this.departmentLoading = true
      await this.apiService
        .get(`department/list/unidade/${this.unidadeId}`)
        .then((response) => {
          this.departments = response.content
        })
        .catch((err) => {
          this.errorMessage = err.body.message
          this.error = true

          setTimeout(() => {
            this.error = false
          }, 4000)
        })

      this.departmentLoading = false
    },

    async getCostCenters() {
      this.costCenterLoading = true

      await this.apiService
        .get(`costCenter/listActive/${this.institutionId}`)
        .then((response) => {
          this.costCenters = response.content
        })
        .catch((err) => {
          this.errorMessage = err.body.message
          this.error = true
          setTimeout(() => {
            this.error = false
          }, 4000)
        })

      this.costCenterLoading = false
    },

    selectedCostCenter() {
      const costCenter = this.costCenters.find(
        (x) => x.departmentId === this.departmentId
      )
      if (costCenter) {
        this.costCenterId = costCenter.id
      }
    },

    async getSuppliers() {
      this.supplierLoading = true
      await this.apiService
        .get(`supplier/list/${this.institutionId}`)
        .then((response) => {
          this.suppliers = response.content
          this.suppliers.unshift({
            id: 0,
            name: '',
          })
        })
        .catch((err) => {
          this.errorMessage = err.body.message
          this.error = true

          setTimeout(() => {
            this.error = false
          }, 4000)
        })

      this.supplierLoading = false
    },

    async submit() {
      this.loading = true

      this.equipment = this.equipment.map((x) => {
        const manuf = this.manufacturers.find((y) => y.name == x.manufacturer)

        x.manufacturerId = manuf.id
        return x
      })

      await this.apiService
        .post('equipment/addRange', this.equipment)
        .then((response) => {
          this.showSuccess(response.message)
          this.close()
        })
        .catch(() => {
          this.loading = false
          this.confirmDialog = false
        })
    },
  },

  watch: {
    fieldDepartment() {
      this.fieldSubDepartment =
        this.fieldDepartment == false ? false : this.fieldSubDepartment
    },
    unidadeId() {
      this.getDepartments()
    },
  },
}
